import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ClientForm from './ClientForm';
import VerifyExistingClient from './VerifyExistingClient';
import { useApplicationStore } from './applicationStore';

const SecureAccount = () => {
	const { getClient, isExistingClient, program } = useApplicationStore();
	const [isExistingConfirmed, setExistingConfirmed] = useState(false);
	const [isClientValid, setIsClientValid] = useState(false);
	const navigate = useNavigate();
	const clientQuestionsQuery = useQuery({
		queryKey: ['clientQuestions', getClient().id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/requests/client-security-questions/${getClient().id}`,
			);
			return data;
		},
		enabled: Boolean(getClient()?.id),
	});

	if (!getClient().name_last && !getClient().name_first) {
		return <Navigate to="/newApplication/profile" replace />;
	}

	if (!isExistingClient) {
		return <Navigate to="/newApplication/secure/new" replace />;
	}

	if (!clientQuestionsQuery.isFetched) {
		return null;
	}

	const isStubbedAccount =
		isEmpty(getClient().last_4_ssn) &&
		isEmpty(getClient().username) &&
		clientQuestionsQuery?.data?.length === 0;

	if (isStubbedAccount) {
		return <Navigate to="/newApplication/secure/new" replace />;
	}

	const handleNext = () => {
		if (program) {
			navigate('/newApplication/confirm');
		} else {
			navigate('/newApplication/search');
		}
	};

	return (
		<>
			<h1>Secure Profile</h1>
			<div className="secure-account">
				{isExistingConfirmed ? (
					<>
						<p>
							<em>
								Confirm profile contact information.{' '}
								<span className="text-error">*</span> Indicates required field
							</em>
						</p>
						<div className="existing-client-form">
							<ClientForm onlyProfile onValidated={setIsClientValid} />
						</div>
					</>
				) : (
					<VerifyExistingClient
						isExistingConfirmed={isExistingConfirmed}
						setExistingConfirmed={setExistingConfirmed}
					/>
				)}
			</div>
			<div className="grid grid-cols-2">
				<div></div>
				<div className="flex justify-end">
					{isExistingConfirmed && (
						<button
							className="btn btn-primary btn-wide"
							disabled={!isClientValid}
							onClick={handleNext}
						>
							Next
						</button>
					)}
				</div>
			</div>
		</>
	);
};

export default SecureAccount;
